import { clsx, type ClassValue } from "clsx";
import { type SyntheticEvent } from "react";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function stopPropagation<E extends SyntheticEvent>(event: E): void {
  event.preventDefault();
  event.stopPropagation();
}
